import { ApisauceInstance } from 'apisauce';

const patchConfiguration = async (
  api: ApisauceInstance,
  permittedGroupIds: string[],
): Promise<boolean> => {
  const response = await api.patch('/v1/sso/microsoft/', {
    permittedGroupIds,
  });
  return response.ok;
};

export default patchConfiguration;
